import React from "react";
import { useTranslation } from "react-i18next";
import { LockIcon } from "../../assets/icons";

export const Forbidden = () => {
  const { t } = useTranslation();

  return (
    <div className={`forbidden-wrapper`}>
      <div className="forbidden-container">
        {/* Lock Icon */}
        <div className="forbidden-icon-container">
          <div className="forbidden-icon">
            <LockIcon
              style={{ width: "100px", height: "100px" }}
              color="currentColor"
              className="forbidden-svg"
            />
          </div>
        </div>

        {/* Forbidden Content */}
        <div className="forbidden-content">
          <h1 className="forbidden-title">
            {t("FORBIDDEN", "Access Forbidden")}
          </h1>

          <p className="forbidden-description">{t("FORBIDDEN_DESCRIPTION")}</p>
        </div>
      </div>
    </div>
  );
};
